import { createLogic } from 'redux-logic';

import { types as propertyTypes } from '../ducks/properties.js';
import propertyApi from '../api/properties';

function generateBaseConfig(type) {
  return {
    type: type,
    latest: true,
    cancelType: `${type}_ERROR`,
    processOptions: {
      dispatchReturn: true,
      successType: `${type}_SUCCESS`,
      failType: `${type}_ERROR`,
    },
  };
}

const getSpaces = createLogic({
  ...generateBaseConfig(propertyTypes.GET_SPACES),
  process({ getState, action }) {
    return propertyApi.getSpaces();
  },
});

const createWorkRequest = createLogic({
  ...generateBaseConfig(propertyTypes.CREATE_WORK_REQUEST),
  process({ getState }) {
    const { currentTenancy } = getState().customer.tenancy.data;
    const { data } = getState().properties.createdWorkRequests;
    const propertyReference = currentTenancy.propertyReference;
    const tenancyRef = currentTenancy.tenancyRef;

    let requestData = data;
    requestData['tenancyReference'] = tenancyRef;
    return propertyApi.createWorkRequest(propertyReference, data);
  },
});

export default [getSpaces, createWorkRequest];
